import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { SmLogoComponent } from "../../components/sm-logo/sm-logo.component";
import { MatDialog } from '@angular/material/dialog';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

@Component({
	selector: 'app-maintenance',
	standalone: true,
	imports: [
    RouterModule, MatButtonModule, MatCheckboxModule,
    MatFormFieldModule, MatInputModule, ReactiveFormsModule,
    CommonModule, MatIconModule,
    SmLogoComponent
],
	templateUrl: './maintenance.component.html',
})
export default class ComponentMaintenance implements OnInit {
	constructor(private matDialog: MatDialog,private matBottomSheet:MatBottomSheet){}
	ngOnInit() {
		this.matDialog.closeAll()
		this.matBottomSheet.dismiss();
	}

}
